import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import CircularProgress from '../../components/CircularProgress';
import Avatar, { avatars } from '../Avatar';
import { GradeContext } from '../../apps/MyStudents';

const initialData = {
  name: '',
  grade: 'kindergarten',
  avatar: 'roly',
  isGradeLocked: false,
  isGradeHidden: false
};

function EditChildModal(props) {
  const {
    child=initialData,
    open=false,
    loading=false,
    error=null,
    yourX= {
      singular: 'child',
      plural: 'children',
    },
    onClose=function(){},
    onSubmit=function(){}
  } = props;

  const [data, setData] = React.useState(initialData);

  const { gradeMap } = useContext(GradeContext);

  const handleNameChange = (e) => {
    setData({...data, name: e.target.value});
  };
  const handleGradeChange = (e) => {
    setData({...data, grade: e.target.value});
  };
  const handleLockGradeToggle = () => {
    setData({...data, isGradeLocked: !data.isGradeLocked})
  };
  const handleHideGradeToggle = () => {
    setData({...data, isGradeHidden: !data.isGradeHidden});
  };
  const handleClickAvatar = (avatar) => {
    setData({...data, avatar});
  };
  const handleSubmit = () => {
    if(child.id == null) return;

    onSubmit(child.id, data);
  };

  React.useEffect(()=> {
    setData({...child});
  }, [child]);

  const avatarImages = Object.keys(avatars).map((variant) => (
    <Avatar
      key={variant}
      variant={variant}
      active={variant === data.avatar}
      onClick={handleClickAvatar}
    />
  ));

  const gradesOptions = [];

  if (gradeMap) {
    gradeMap.availableGrades.forEach((grade) => {
      gradesOptions.push(
        <option key={gradeMap[grade].shortId} value={gradeMap[grade].shortId}>{gradeMap[grade].longDisplay}</option>);
    });
  }

  return (
    <Modal open={open} onClose={onClose} className="edit-child-modal">
      <div className="title">Edit {yourX.singular} profile</div>
      <div className="modal-inner">
        <form className="form flex-container flex-wrap" onSubmit={handleSubmit}>
          <div className="form-fields">
            <div className={clsx('form-row input-row name', error && 'has-error')}>
              <label className={clsx('floating', data.name !== '' && 'not-empty')}>
                <span>{yourX.singular}'s first name</span>
                <input type="text" name="name" required value={data.name} onChange={handleNameChange} />
              </label>
              {error && (
                <p className="error">{error}</p>
              )}
            </div>
            <div className="form-row input-row grade">
              <label className="floating not-empty">
                <span>Choose grade level</span>
                <select name="grade" value={data.grade} onChange={handleGradeChange}>
                  {gradesOptions}
                </select>
              </label>
            </div>
            <div className="form form-childLock">
              <div className="toggle-form lock-grade">
                <strong><i className="icon-info-circled"><div className="tooltip">When locked,
                  your child must stay within the chosen grade level in Guided Lessons.</div></i>Lock grade</strong>
                <label className={clsx('toggle-switch-small', data.isGradeLocked && 'active')} onClick={handleLockGradeToggle}>
                  <div className="switch"></div>
                </label>
              </div>
              <div className="toggle-form hide-grade">
                <strong><i className="icon-info-circled"><div className="tooltip">When hidden,
                  your child will not see their grade in Guided Lessons.</div></i>Hide grade</strong>
                <label className={clsx('toggle-switch-small', data.isGradeHidden && 'active')} onClick={handleHideGradeToggle}>
                  <div className="switch"></div>
                </label>
              </div>
            </div>
          </div>
          <div className="avatars-container flex-container flex-wrap">
            {avatarImages}
          </div>
          <div className="btn-container">
            <Button size="large" color="secondary" onClick={onClose}>Cancel</Button>
            <Button size="large" color="primary" disabled={loading} onClick={handleSubmit}>
              {loading && (<CircularProgress color="brand" />)}
              Save
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

EditChildModal.propTypes = {
  child: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    grade: PropTypes.string,
    avatar: PropTypes.string,
    isGradeLocked: PropTypes.bool,
    isGradeHidden: PropTypes.bool,
    yourX: PropTypes.object
  }),
  open: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func
};
export default EditChildModal;
